import { derived, writable } from 'svelte/store'
import { web3, selectedAccount } from 'svelte-web3'
import Exchange from './Exchanage-contract-store'
import { ETHER_Address, tokens, ether, GREEN, RED } from "../helpers"
import moment from "moment";
import { get, reject, groupBy, maxBy, minBy } from "lodash";


const loadOrders = async ($Exchange) => {
    let allOrders;
    let filledOrders;
    let cancelledOrders;
    let orderBookOrders;
    let myFilledOrdersList
    let myOpenOrdersList
    let orders = { allOrders, filledOrders, cancelledOrders, orderBookOrders, myFilledOrdersList, myOpenOrdersList };
    //Cancelled Orders
    let canceledStream = await $Exchange.getPastEvents("Cancel", {
        fromBlock: 0,
        toBlock: "latest",
    });
    orders.cancelledOrders = canceledStream.map(
        (event) => event.returnValues
    );
    
    //Filled Orders
    let tradeStream = await $Exchange.getPastEvents("Trade", {
        fromBlock: 0,
        toBlock: "latest",
    });
    orders.filledOrders = tradeStream.map((event) => event.returnValues);
       
    // Decorate the orders
    orders.filledOrders = decorateFilledOrders(orders.filledOrders);
    // Sort orders by date descending for display
    orders.filledOrders.sort(
        (a, b) => a.id-b.id)
    //All Orders
    let orderStream = await $Exchange.getPastEvents("Order", {
        fromBlock: 0,
        toBlock: "latest",
    });
    orders.allOrders = orderStream.map((event) => event.returnValues);
    //Initital Call of the Event subscription function
    await subscribeToEvents($Exchange)
    return orders

}
const injectOrderBook = async ($Exchange, $selectedAccount) => {
    let orders = await loadOrders($Exchange)
    
    orders.orderBookOrders = await orderBook(openOrders (orders))
    orders.myFilledOrdersList = await myFilledOrders($selectedAccount, orders.filledOrders);
    orders.myOpenOrdersList = await myOpenOrders($selectedAccount, openOrders(orders));
    return orders
}

const decorateFilledOrders = (orders) => {
    // Track previous order to compare history
    let previousOrder = orders[0];

    return orders.map((order) => {
        order = decorateOrder(order);
        order = decorateFilledOrder(order, previousOrder);
        previousOrder = order; // Update the previous order once it's decorated
        return order;
    });
};
function decorateOrder(order) {
    let etherAmount;
    let tokenAmount;

    if (order.tokenGive == ETHER_Address) {
        etherAmount = order.amountGive;
        tokenAmount = order.amountGet;
    } else {
        etherAmount = order.amountGet;
        tokenAmount = order.amountGive;
    }
    //Calc Token price
    const precision = 100000;
    let tokenPrice = etherAmount / tokenAmount;
    tokenPrice = Math.round(tokenPrice * precision) / precision;

    return {
        ...order,
        etherAmount: ether(etherAmount),
        tokenAmount: tokens(tokenAmount),
        tokenPrice: tokenPrice,
        formattedTimestamp: moment
            .unix(order.timestamp)
            .format("DD.MM.YY HH:mm:ss"),
    };
}

const decorateFilledOrder = (order, previousOrder) => {
    return {
        ...order,
        tokenPriceClass: tokenPriceClass(
            order.tokenPrice,
            order.id,
            previousOrder
        ),
    };
};

const tokenPriceClass = (tokenPrice, orderId, previousOrder) => {
    // Show green price if only one order exists
    if (previousOrder.id === orderId) {
        return GREEN;
    }

    // Show green price if order price higher than previous order
    // Show red price if order price lower than previous order
    if (previousOrder.tokenPrice <= tokenPrice) {
        return GREEN; // success
    } else {
        return RED; // danger
    }
};
// Create the order book
const openOrders = (orders) => {
		const all = orders.allOrders;
		const filled = orders.filledOrders;
		const cancelled = orders.cancelledOrders;

		const openOrders = reject(all, (order) => {
			const orderFilled = filled.some((o) => o.id === order.id);
			const orderCancelled = cancelled.some((o) => o.id === order.id);
			return orderFilled || orderCancelled;
		});
        return openOrders;
};

const orderBook = (openOrders, (orders) => {
			// Decorate orders
			orders = decorateOrderBookOrders(orders);
			// Group orders by "orderType"
			orders = groupBy(orders, "orderType");
			// Fetch buy orders
			const buyOrders = get(orders, "buy", []);
			// Sort buy orders by token price
			orders = {
				...orders,
				buyOrders: buyOrders.sort(
					(a, b) => b.tokenPrice - a.tokenPrice
				),
			};
			// Fetch sell orders
			const sellOrders = get(orders, "sell", []);
			// Sort sell orders by token price
			orders = {
				...orders,
				sellOrders: sellOrders.sort(
					(a, b) => b.tokenPrice - a.tokenPrice
				),
			};
			return orders;
});

const decorateOrderBookOrders = (orders) => {
		return orders.map((order) => {
			order = decorateOrder(order);
			order = decorateOrderBookOrder(order);
			return order;
		});
};

const decorateOrderBookOrder = (order) => {
		const orderType = order.tokenGive === ETHER_Address ? "buy" : "sell";
		return {
			...order,
			orderType,
			orderTypeClass: orderType === "buy" ? GREEN : RED,
			orderFillAction: orderType === "buy" ? "sell" : "buy",
		};
};
//My filled orders
const myFilledOrders = (account, orders) => {
		// Find our orders
		orders = orders.filter(
			(o) =>
				o.user.toLowerCase() === account ||
				o.userFill.toLowerCase() === account
		);
		// Sort by date ascending
		orders = orders.sort((b, a) => a.timestamp - b.timestamp);
		// Decorate orders - add display attributes
		orders = decorateMyFilledOrders(orders, account);
		return orders;
};

const decorateMyFilledOrders = (orders, account) => {
		return orders.map((order) => {
			order = decorateOrder(order);
			order = decorateMyFilledOrder(order, account);
			return order;
		});
};

const decorateMyFilledOrder = (order, account) => {
		const myOrder = order.user.toLowerCase() === account;

		let orderType;
		if (myOrder) {
			orderType = order.tokenGive === ETHER_Address ? "buy" : "sell";
		} else {
			orderType = order.tokenGive === ETHER_Address ? "sell" : "buy";
		}

		return {
			...order,
			orderType,
			orderTypeClass: orderType === "buy" ? GREEN : RED,
			orderSign: orderType === "buy" ? "+" : "-",
		};
};
//My open Orders
const myOpenOrders = (account, orders) => {
		// Filter orders created by current account
		orders = orders.filter((o) => o.user.toLowerCase() === account);
		// Decorate orders - add display attributes
		orders = decorateMyOpenOrders(orders);
		// Sort orders by date descending
		orders = orders.sort((a, b) => b.timestamp - a.timestamp);
		return orders;
};

const decorateMyOpenOrders = (orders, account) => {
		return orders.map((order) => {
			order = decorateOrder(order);
			order = decorateMyOpenOrder(order);
			return order;
		});
};

const decorateMyOpenOrder = (order) => {
		let orderType = order.tokenGive === ETHER_Address ? "buy" : "sell";

		return {
			...order,
			orderType,
			orderTypeClass: orderType === "buy" ? GREEN : RED,
		};
};

//APEX Chart
const getPriceSymbol = (lastPriceChange) => {
		
    if (lastPriceChange === "+") {
        priceSymbol = '<span class="text-success">&#9650;</span>'; // Green up triangle
    } else {
        priceSymbol = '<span class="text-danger">&#9660;</span>'; // Red down triangle
    }
    return priceSymbol;
};

// Building chart data with filled orders
const createPriceChart = (orders) => {
    // Sort orders by date ascending to compare history
    orders = orders.sort((a, b) => a.timestamp - b.timestamp);
    // Decorate orders - add display attributes
    orders = orders.map((o) => decorateOrder(o));
    // Get last 2 order for final price & price change
    let secondLastOrder, lastOrder;
    [secondLastOrder, lastOrder] = orders.slice(
        orders.length - 2,
        orders.length
    );
    // get last order price
    const lastPrice = get(lastOrder, "tokenPrice", 0);
    // get second last order price
    const secondLastPrice = get(secondLastOrder, "tokenPrice", 0);

    return {
        lastPrice,
        lastPriceChange: lastPrice >= secondLastPrice ? "+" : "-",
        series: [
            {
                data: buildGraphData(orders),
            },
        ],
        chart: {
            animations: { enabled: false },
            toolbar: { show: false },
            width: "100%",
            height: "260px",
            type: "candlestick",
        },
        tooltip: {
            enabled: true,
            theme: false,
            style: {
                fontSize: "12px",
                fontFamily: undefined,
            },
            x: {
                show: false,
                format: "dd MMM",
                formatter: undefined,
            },
            y: {
                show: true,
                title: "price",
            },
            marker: {
                show: false,
            },
            items: {
                display: "flex",
            },
            fixed: {
                enabled: false,
                position: "topRight",
                offsetX: 0,
                offsetY: 0,
            },
        },
        xaxis: {
            type: "datetime",
            labels: {
                show: true,
                style: {
                    colors: "#fff",
                    fontSize: "12px",
                    cssClass: "apexcharts-xaxis-label",
                },
            },
        },
        yaxis: {
            labels: {
                show: true,
                minWidth: 0,
                maxWidth: 160,
                style: {
                    colors: "#eff",
                    fontSize: "12px",
                    cssClass: "apexcharts-yaxis-label",
                },
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
            },
        },
    };
};

const buildGraphData = (orders) => {
    // Group the orders by hour for the graph
    orders = groupBy(orders, (o) =>
        moment.unix(o.timestamp).startOf("hour").format()
    );
    // Get each hour where data exists
    const hours = Object.keys(orders);
    // Build the graph series
    const graphData = hours.map((hour) => {
    // Fetch all the orders from current hour
    const group = orders[hour];
    // Calculate price values - open, high, low, close
    const open = group[0]; // first order
    const high = maxBy(group, "tokenPrice"); // high price
    const low = minBy(group, "tokenPrice"); // low price
    const close = group[group.length - 1]; // last order

    return {
        x: new Date(hour),
        y: [
            open.tokenPrice,
            high.tokenPrice,
            low.tokenPrice,
            close.tokenPrice,
        ],
    };
    });

    return graphData;
};
//Set to log Blocknumbers to prevent multiple event fires per event
let eventBlocks = new Set()

//Subscribing to Contract Events
//Possible TODO: Split events in Deposit/Withdraw and Order related ones to prevent unneccesary order triggers
const subscribeToEvents = async ($Exchange) => {
    
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    //Triggering order update     
    const triggerEvent = async (type) => {
        trigger.event()
        console.log("New", type, "Event")
    }
    //Debouncer
    let available = true
    async function debouncer() {
        if (available) {
            available = false
            triggerEvent("Any")
            await sleep(300)
            available = true
        }
    }
    //Subscribe to all Contract Events
    $Exchange.events.allEvents({fromBlock : "latest"}, async (error, event) => {
        if (error) { console.log(error); }
        else {
            let blockNumber = event.blockNumber;
            if (eventBlocks.has(blockNumber)) return;
            eventBlocks.add(blockNumber);
            debouncer()
            console.log(eventBlocks)
        }
    })
}

//Trigger for updating the orders 
function createTrigger() {
	const { subscribe, set, update } = writable(false);

	return {
		subscribe,
		event: () => update(n => !n),
		reset: () => set(false)
	}
}
export const trigger = createTrigger()

//Store with all the orders
export const orders = (derived([web3,Exchange, selectedAccount, trigger], async ([$web3, $Exchange, $selectedAccount, $trigger], set) =>  {
    if ($Exchange && $web3 && $selectedAccount) {
        await injectOrderBook($Exchange, $selectedAccount).then(set)
    }
    return null    
}))

//Store for the chart data
export const chartData = (derived(orders, ($orders) =>  {
    if ($orders) {
        return createPriceChart($orders.filledOrders)
    }    
}))